import { Routes } from '@angular/router';

export const profileRoutes: Routes = [
  {
    path: '',
    redirectTo: '/tabs/profile',
    pathMatch: 'full',
  },
  {
    path: 'family-details',
    loadComponent: () =>
      import('#pages/family-details/family-details.page').then((m) => m.FamilyDetailsPage),
  },
  {
    path: 'designated-contacts',
    loadComponent: () =>
      import('#pages/designated-contacts/designated-contacts.page').then(
        (m) => m.DesignatedContactsPage
      ),
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('#pages/change-password/change-password.page').then((m) => m.ChangePasswordPage),
  },
  {
    path: 'family-details/family-member/:id',
    loadComponent: () =>
      import('#pages/family-member/family-member.page').then((m) => m.FamilyMemberPage),
  },
  {
    path: 'family-details/family-member',
    loadComponent: () =>
      import('#pages/family-member/family-member.page').then((m) => m.FamilyMemberPage),
  },
  {
    path: 'designated-contacts/designated-contact/:id',
    loadComponent: () =>
      import('#pages/designated-contact/designated-contact.page').then(
        (m) => m.DesignatedContactPage
      ),
  },
  {
    path: 'designated-contacts/designated-contact',
    loadComponent: () =>
      import('#pages/designated-contact/designated-contact.page').then(
        (m) => m.DesignatedContactPage
      ),
  },
  {
    path: 'delete-account',
    loadComponent: () =>
      import('#pages/delete-user/delete-user.page').then((m) => m.DeleteUserPage),
  },
];
